// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"fj-z","play":"gj-z"};